<p-confirmDialog header="Confirmation" key="confirmDelete" icon="pi pi-exclamation-triangle"
[style]="{width: '350px'}" acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text" />
<div class="card">
  <div class="flex justify-center items-center">
    <div class="grid place-items-center pt-0 mb-2">
      <div class="pb-0">
        <h5>{{!project || !project.id ? 'Create' : 'Edit'}} Project Profile</h5>
      </div>
      <div class=" pr-0 pt-0 relative top-0 left-0">
        <img src="../../../../assets/badges/writer.png" class="right-0 top-0"/>
      </div>
    </div>
  </div>
  <div>
    @if (project) {
      <div class="card grid grid-cols-3 pt-0 mt-0 justify-items-center">
        <div class="pt-5 w-full col-span-full">
          <p-floatlabel>
            <input [pTooltip]="" tooltipPosition="top"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border rounded-border appearance-none outline-none focus:border-primary w-full"
              type="text" id="title" pInputText [(ngModel)]="project.title">
            <label for="title">Title</label>
          </p-floatlabel>
        </div>
        <div class="pt-5 w-full items-center col-span-full">
          <label for="seekingBeta">Search for Beta Readers </label>
          <br>
          <p-toggleSwitch id="seekingBeta" [(ngModel)]="project.lookingForBetaReaders" />
        </div>
        <div class="pt-5 pb-2 w-full col-span-4">
          <span>
            <label for="summary"> Summary <i class="pi pi-question-circle" pTooltip="Tooltip" style="font-size: 1rem"></i></label>
            <textarea rows="6"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border rounded-border appearance-none outline-none focus:border-primary w-full"
            type="text" inputId="summary" id="summary" pInputTextArea [(ngModel)]="project.summary"></textarea>
          </span>
        </div>
        @if (!project.profileGroup) {
            <p-skeleton width="100%" height="150px" />
        }
        @if (project.profileGroup) {
          <div class="pt-5 pb-2 w-full col-span-full">
                <span>
                    <div>
                        <label for="last_info"> Last Info <i class="pi pi-question-circle" pTooltip="Tooltip" style="font-size: 1rem"></i></label>

                    </div>
                    <app-writer-templates [for]="'last_info'"></app-writer-templates>
                    <textarea rows="6"
                          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border rounded-border appearance-none outline-none focus:border-primary w-full"
                          type="text" inputId="last_info" id="last_info" pInputTextArea [(ngModel)]="project.lastInfo">
                        </textarea>
                    <!--p-editor #editor [(ngModel)]="project.lastInfo" [style]="{height: '320px'}" id="last_info"></p-editor-->

                </span>
            </div>
            <!--the following div seems to cause a lot of red in the console if there's a col-span-full class that contains the project-descriptor-panel, it doesn't appear to be fatal however?-->
            <div class="col-span-full w-full">
              <project-descriptor-panel [schemaDisplay]="ProjectSchemas.SCHEMADISPLAY_BY_CODE[project.schemaCode]" [use]="ProjectDescriptorUse.WRITER_PROJECT" [profileGroup]="project.profileGroup" />
            </div>
        }
        <p-button class="col-start-2 pt-3" [label]="!project.id ? 'Create Project' : 'Save Project'" icon="pi pi-save" (onClick)="save()"  />
      </div>
    }
  </div>
</div>
